export default __webpack_public_path__ + "static/media/Gotham-Medium.d6e50a8b.otf";